import _Vue from "vue";
import {adres} from "@/entity/AdresEntity";
export class Helper {
    tcKimlikNoValidate(tcKimlikNo: string): boolean {
        let toplam = Number(tcKimlikNo.substring(0, 1)) + Number(tcKimlikNo.substring(1, 2)) +
            Number(tcKimlikNo.substring(2, 3)) + Number(tcKimlikNo.substring(3, 4)) +
            Number(tcKimlikNo.substring(4, 5)) + Number(tcKimlikNo.substring(5, 6)) +
            Number(tcKimlikNo.substring(6, 7)) + Number(tcKimlikNo.substring(7, 8)) +
            Number(tcKimlikNo.substring(8, 9)) + Number(tcKimlikNo.substring(9, 10));
        let strtoplam = String(toplam);
        let onunbirlerbas = strtoplam.substring(strtoplam.length, strtoplam.length - 1);
        if (onunbirlerbas == tcKimlikNo.substring(10, 11)) {
            return true;
            //alert("doğru");
        } else {
            return false;
            //alert("yanlış");
        }
    }
    errorHandler(e:any):string{
        let responseText = "";
        if(typeof e.response != "undefined"){
            if(typeof e.response.data.messages != "undefined"){
                e.response.data.messages.forEach((message:any)=>{
                    responseText += message.message +" - ";
                })
            }
            if(typeof e.response.data.message != "undefined"){
                responseText = e.response.data.message;
            }
        }else{
            responseText = e.message;
        }
        return responseText;
    }
    capitalize(str:string):string{
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    onlyDigit(str:string):string{
        return str.replace(/[^0-9]/g,"");
    }
    seoUrl(textString:string|undefined):string|undefined {
        if(textString == undefined)
            return "";
        textString = textString.replace(/ /g, "-");
        textString = textString.replace(/</g, "");
        textString = textString.replace(/>/g, "");
        textString = textString.replace(/"/g, "");
        textString = textString.replace(/é/g, "");
        textString = textString.replace(/!/g, "");
        textString = textString.replace(/’/, "");
        textString = textString.replace(/£/, "");
        textString = textString.replace(/^/, "");
        textString = textString.replace(/#/, "");
        textString = textString.replace(/$/, "");
        textString = textString.replace(/\+/g, "");
        textString = textString.replace(/%/g, "");
        textString = textString.replace(/½/g, "");
        textString = textString.replace(/&/g, "");
        textString = textString.replace(/\//g, "");
        textString = textString.replace(/{/g, "");
        textString = textString.replace(/\(/g, "");
        textString = textString.replace(/\[/g, "");
        textString = textString.replace(/\)/g, "");
        textString = textString.replace(/]/g, "");
        textString = textString.replace(/=/g, "");
        textString = textString.replace(/}/g, "");
        textString = textString.replace(/\?/g, "");
        textString = textString.replace(/\*/g, "");
        textString = textString.replace(/@/g, "");
        textString = textString.replace(/€/g, "");
        textString = textString.replace(/~/g, "");
        textString = textString.replace(/æ/g, "");
        textString = textString.replace(/ß/g, "");
        textString = textString.replace(/;/g, "");
        textString = textString.replace(/,/g, "");
        textString = textString.replace(/`/g, "");
        textString = textString.replace(/|/g, "");
        textString = textString.replace(/\./g, "");
        textString = textString.replace(/:/g, "");
        textString = textString.replace(/İ/g, "i");
        textString = textString.replace(/I/g, "i");
        textString = textString.replace(/ı/g, "i");
        textString = textString.replace(/ğ/g, "g");
        textString = textString.replace(/Ğ/g, "g");
        textString = textString.replace(/ü/g, "u");
        textString = textString.replace(/Ü/g, "u");
        textString = textString.replace(/ş/g, "s");
        textString = textString.replace(/Ş/g, "s");
        textString = textString.replace(/ö/g, "o");
        textString = textString.replace(/Ö/g, "o");
        textString = textString.replace(/ç/g, "c");
        textString = textString.replace(/Ç/g, "c");
        textString = textString.replace(/–/g, "-");
        textString = textString.replace(/—/g, "-");
        textString = textString.replace(/—-/g, "-");
        textString = textString.replace(/—-/g, "-");
        return textString.toLowerCase();
    }
    sendWatsappMessage(adrs:adres){
        window.open("https://api.whatsapp.com/send?phone=9"+this.parsePhone(adrs.phone)+"&text=Merhaba%2C%20"+adrs.name+"%20"+adrs.lastname,"_blank");
    }
    parsePhone(phone:string){
        if(phone){
            return "0"+this.onlyDigit(phone);
        }
        return "";
    }
}


export default function HelperPlugin(Vue: typeof _Vue, options?: any): void {
    Vue.prototype.$helper = new Helper();
}
